import { render, staticRenderFns } from "./SensorChart.vue?vue&type=template&id=22cb76be&scoped=true&lang=pug"
import script from "./SensorChart.vue?vue&type=script&lang=js"
export * from "./SensorChart.vue?vue&type=script&lang=js"
import style0 from "./SensorChart.vue?vue&type=style&index=0&id=22cb76be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb76be",
  null
  
)

export default component.exports